const EMAIL_REGEX = new RegExp(process.env.KOOTH_EMAIL_REGEX);

export default values => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = __('validations.required');
  }

  if (!values.lastName) {
    errors.lastName = __('validations.required');
  }

  if (!EMAIL_REGEX.test(values.emailAddress)) {
    errors.emailAddress = __('validations.email');
  }

  if (values.emailAddressConfirm !== values.emailAddress) {
    errors.emailAddressConfirm = __('validations.emailMatch');
  }

  if (!values.preferredLocation) {
    errors.preferredLocation = true;
  }

  if (!values.postcode) {
    errors.postcode = __('validations.required');
  }

  if (!values.dob) {
    errors.dob = __('validations.required');
  }

  if (!values.childProtection) {
    errors.childProtection = true;
  }

  if (!values.additionalNeeds) {
    errors.additionalNeeds = true;
  }

  if (!values.legalProceedings) {
    errors.legalProceedings = true;
  }

  if (!values.school) {
    errors.school = true;
  }

  if (!values.preferredLanguage) {
    errors.preferredLanguage = true;
  }

  if (!values.townCity) {
    errors.townCity = __('validations.required');
  }

  if (!values.school) {
    errors.school = __('validations.required');
  }

  if (!values.preferredLanguage) {
    errors.preferredLanguage = __('validations.required');
  }

  if (!values.childProtection) {
    errors.childProtection = __('validations.required');
  }

  if (!values.additionalNeeds) {
    errors.additionalNeeds = __('validations.required');
  }

  if (!values.legalProceedings) {
    errors.legalProceedings = __('validations.required');
  }

  if (values.contactBy && Object.values(values.contactBy).every(value => value === false)) {
    errors.contactBy = __('validations.atLeastOne');
  }

  return errors;
};




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/validate.js
 **/